namespace GeniuzPOS.Lookups {
    export namespace VwcsParaService {
        export const baseUrl = 'Lookups/VwcsPara';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwcsParaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwcsParaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwcsPara/Retrieve",
            List = "Lookups/VwcsPara/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwcsParaService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
